function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M50 13.749c-20 0-36.667 16.25-36.667 36.667 0 20 16.25 36.666 36.667 36.666 20 0 36.666-16.25 36.666-36.666C86.666 29.999 70 13.749 50 13.749zm0 66.667c-16.667 0-30-13.75-30-30 0-17.084 13.333-30.417 30-30.417 16.666 0 30 13.75 30 30 0 16.667-13.334 30.417-30 30.417z",
  fill: "#1d1d1b"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.583 36.666v27.5l21.667-13.75",
  fill: "#1d1d1b"
});

function SvgPlaylight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "7af88e4d646b65f6021cf621ff74977b.svg";
export { SvgPlaylight as ReactComponent };